import React from "react";

export default function WhatsAppFloat({ number }) {
  const raw = (number || "+91XXXXXXXXXX").replace(/[^0-9+]/g, "");
  const url = `https://wa.me/${raw.replace("+", "")}?text=${encodeURIComponent("Hello SSK Enterprises, I would like to request a quotation.")}`;
  return (
    <a href={url} target="_blank" rel="noreferrer"
       className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center wa-pulse shadow-lg"
       aria-label="Chat on WhatsApp" data-testid="whatsapp-float">
      <svg viewBox="0 0 32 32" className="w-7 h-7" fill="white">
        <path d="M19.11 17.31c-.28-.14-1.65-.81-1.9-.9-.25-.09-.44-.14-.62.14-.18.28-.71.9-.87 1.09-.16.19-.32.21-.6.07-.28-.14-1.19-.44-2.27-1.4-.84-.75-1.4-1.67-1.57-1.95-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.54-.45-.47-.62-.48l-.53-.01c-.19 0-.49.07-.75.35-.25.28-.98.96-.98 2.33 0 1.37 1 2.7 1.14 2.88.14.19 1.98 3.03 4.8 4.24.67.29 1.19.46 1.6.59.67.21 1.28.18 1.77.11.54-.08 1.65-.67 1.89-1.32.23-.65.23-1.2.16-1.32-.07-.11-.25-.18-.53-.32zM16 4C9.37 4 4 9.37 4 16c0 2.11.55 4.09 1.51 5.81L4 28l6.36-1.67A11.95 11.95 0 0 0 16 28c6.63 0 12-5.37 12-12S22.63 4 16 4z"/>
      </svg>
    </a>
  );
}
